$(document).ready(function(){
    
    //////////////////////////////////////////////////////////////////////////
    //				AFFICHAGE / MASQUAGE DES PANELS 
    //////////////////////////////////////////////////////////////////////////

    function open_panel(panel_name){
        $('.panel[data-panel="' + panel_name + '"]').addClass('isOpen');
    }
    function close_panel(){
        $('.panel').removeClass('isOpen');
    }

    ////////////////// OUVRIR LES PANELS //////////////////

    $('[data-open-panel]').on('click', function(){
        var $_panel_name = $(this).attr('data-open-panel');
        open_panel($_panel_name);
        return false;
    });
    
    ////////////////// FERMER LES PANELS //////////////////

    // Clic sur la croix
    $('.panel-fermer').on('click', close_panel);

    // Avec la touche echap
	$(window).on('keydown', function (event) {
		if (event.keyCode == 27) {
			close_panel();
		}
    });
    
	// Click outside
	$('body').on('click', close_panel);
	$('.panel-container, [data-open-panel]').click(function (event) {
		event.stopPropagation();
	});




});